import { fromJS } from 'immutable'
import {
  LEAVE_ENTITLEMENT_EDIT_REQUEST,
  LEAVE_ENTITLEMENT_EDIT_SUCCESS,
  LEAVE_ENTITLEMENT_EDIT_FAILURE,
  LEAVE_ENTITLEMENT_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_ENTITLEMENT_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_ENTITLEMENT_EDIT_SUCCESS:
      return state
        .set('updateLeaveEntitlement', fromJS(action.payload.updateLeaveEntitlment))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('updateLeaveEntitlement', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_EDIT_RESET:
      return state
        .delete('updateLeaveEntitlement')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-entitlement/leave-entitlement-edit-reducer.js